module.exports = __webpack_public_path__ + "img/header.1b96d2f.svg";